// A dead tree: a bare, weathered grey trunk with a few bare branches that
// actually JOIN the trunk (each branch's inner end sits on the trunk where it
// forks) and taper off into the air. No foliage. Ported 1:1 from age-of-mcp's
// classic dead-tree.ts, restoring its `branch` helper.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const trunkH = 1.0;
  const parts: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.05, 0.1, trunkH, 5),
      color: "#8a8174", position: [0, trunkH / 2, 0] },
  ];
  // A branch attached at trunk height `hy`, length L, leaning `tilt` from
  // vertical toward angle `a`. Positioned so its inner end meets the trunk.
  const branch = (hy: number, a: number, L: number, tilt: number, col: string): Part => ({
    geometry: new THREE.CylinderGeometry(0.018, 0.04, L, 4),
    color: col,
    position: [Math.cos(a) * Math.sin(tilt) * L / 2, hy + Math.cos(tilt) * L / 2, Math.sin(a) * Math.sin(tilt) * L / 2],
    rotation: [Math.sin(a) * tilt, 0, -Math.cos(a) * tilt],
  });
  parts.push(branch(0.72, 0.0,           0.5,  0.8, "#7e756a"));
  parts.push(branch(0.6,  Math.PI,       0.46, 0.9, "#7e756a"));
  parts.push(branch(0.86, Math.PI * 0.5, 0.4,  0.7, "#736a60"));
  parts.push(branch(0.95, Math.PI * 1.4, 0.34, 0.5, "#736a60"));
  return parts;
}

export const deadTree = defineModel({
  id: "dead-tree",
  batchId: "standard",
  name: "Dead tree",
  tags: ["scenery","dead","tree","low-poly","age-of-mcp","classic"],
  summary: "Low-poly dead tree.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => partsFor(),
  animations: [],
});
